/* Independent of Shrine's cart scripts: native Shopify forms remain functional without JS. */
(() => {
  function init(root = document) {
    root.querySelectorAll('.sp-reviews').forEach(section => {
      if (section.dataset.spReady) return;
      section.dataset.spReady = 'true';
      const track = section.querySelector('.sp-review-track');
      const previous = section.querySelector('[data-sp-prev]');
      const next = section.querySelector('[data-sp-next]');
      if (!track || !previous || !next) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const move = direction => track.scrollBy({left: direction * track.clientWidth * .9, behavior: reduced ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      const update = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Pack selector: radio cards in one form. Keeps selected styling, the CTA total and the sticky bar in sync. */
(() => {
  function sync(form) {
    const checked = form.querySelector('.sp-pack-radio:checked');
    form.querySelectorAll('.sp-pack').forEach(card => card.classList.toggle('is-selected', card.contains(checked)));
    if (!checked) return;
    const total = form.querySelector('[data-sp-cta-total]');
    if (total) total.textContent = checked.dataset.spTotal;
    if (form.closest('.sp-product')) {
      const heading = checked.closest('.sp-pack').querySelector('h3');
      document.querySelectorAll('[data-sp-sticky-total]').forEach(el => { el.textContent = checked.dataset.spTotal; });
      if (heading) document.querySelectorAll('[data-sp-sticky-name]').forEach(el => { el.textContent = heading.textContent.trim(); });
    }
  }
  function initPacks(root = document) {
    root.querySelectorAll('[data-sp-pack-form]').forEach(form => {
      if (form.dataset.spPacksReady) return;
      form.dataset.spPacksReady = 'true';
      form.addEventListener('change', () => sync(form));
      sync(form);
    });
  }
  window.spSelectPack = (quantity) => {
    document.querySelectorAll('[data-sp-pack-form]').forEach(form => {
      const radio = form.querySelector(`.sp-pack-radio[value="${quantity}"]`);
      if (!radio) return;
      radio.checked = true;
      sync(form);
      form.dispatchEvent(new Event('change', {bubbles: true}));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initPacks());
  else initPacks();
  document.addEventListener('shopify:section:load', event => initPacks(event.target));
})();

/* "Choose your pack" links: scroll so the pack options sit centred in the viewport. */
(() => {
  const hashes = ['#packs', '#sipsy-purchase'];
  const target = () => document.querySelector('.sp-product [data-sp-pack-form]') || document.querySelector('#packs [data-sp-pack-form]') || document.querySelector('#packs');
  const centre = smooth => {
    const el = target();
    if (!el) return false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({behavior: smooth && !reduced ? 'smooth' : 'auto', block: 'center'});
    return true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="#"]');
    if (!link || link.hasAttribute('data-sp-sticky-buy')) return;
    const url = new URL(link.href, window.location.href);
    if (!hashes.includes(url.hash) || url.pathname !== window.location.pathname) return;
    if (!target()) return;
    event.preventDefault();
    centre(true);
    if (history.replaceState) history.replaceState(null, '', url.hash);
  });
  const onLoad = () => { if (hashes.includes(window.location.hash)) setTimeout(() => centre(false), 50); };
  if (document.readyState === 'complete') onLoad();
  else window.addEventListener('load', onLoad);
})();

/* Sticky buy bar on the product page (desktop and mobile): shows once the Preorder Now button has scrolled above the viewport. */
(() => {
  function initSticky() {
    const bar = document.querySelector('[data-sp-sticky]');
    const form = document.querySelector('.sp-product [data-sp-pack-form]');
    const button = form && form.querySelector('.sp-pack-submit');
    if (!bar || !form || !button || !('IntersectionObserver' in window)) return;
    const show = visible => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      const link = bar.querySelector('[data-sp-sticky-buy]');
      if (link) link.tabIndex = visible ? 0 : -1;
    };
    new IntersectionObserver(([entry]) => {
      show(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }).observe(button);
    const buy = bar.querySelector('[data-sp-sticky-buy]');
    if (buy) buy.addEventListener('click', event => {
      const submit = form.querySelector('.sp-pack-submit:not(:disabled)');
      if (!submit) return;
      event.preventDefault();
      submit.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();

/* Compact native-details navigation and pack deep links (?sipsy_pack=1|2|4). */
(() => {
  function initNavigation(root = document) {
    root.querySelectorAll('.sp-mobile-nav').forEach(menu => {
      if (menu.dataset.spNavReady) return;
      menu.dataset.spNavReady = 'true';
      const summary = menu.querySelector('summary');
      const sync = () => {
        summary.setAttribute('aria-expanded', String(menu.open));
        summary.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
      };
      menu.addEventListener('toggle', sync);
      menu.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => {
        menu.open = false;
        sync();
      }));
      sync();
    });
  }
  function selectedPack() {
    let option = new URLSearchParams(window.location.search).get('sipsy_pack');
    if (option === '3') option = '4';
    if (!['1', '2', '4'].includes(option) || !window.spSelectPack) return;
    window.spSelectPack(option);
  }
  const ready = () => { initNavigation(); selectedPack(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', event => initNavigation(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sp-mobile-nav[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
      menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      menu.querySelector('summary').setAttribute('aria-label', 'Open menu');
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.sp-mobile-nav[open]').forEach(menu => {
      if (!menu.contains(event.target)) {
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
        menu.querySelector('summary').setAttribute('aria-label', 'Open menu');
      }
    });
  });
})();
